export const containerListFetch = criteria => async (dispatch, getState, { api }) => api.getContainers(criteria);
